import { render, staticRenderFns } from "./TokensSummary.vue?vue&type=template&id=746d55b2&"
import script from "./TokensSummary.vue?vue&type=script&lang=ts&"
export * from "./TokensSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports